import React from 'react';
import PropTypes from 'prop-types';

import 'assets/css/confetti.css';

import { publicReward } from 'utils/urls';
import { rewardPDFDownload } from 'utils/urls';
import { downloadFileFromUrl } from 'utils/downloadFile';
import SocialIcons from 'utils/SocialShare/ShareButtons/SocialIcons';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import { IconButton } from '@mui/material';

import { t } from 'i18n/index';


const ShareRewardModal = ({ open, description, reward={}, showCelebration=false, onClose, viewOnPublic, showIcons}) => {

  const certificate = (reward && reward.category === 'achievement') && true;
  const handlePDFDownload = () => {
    const id = reward.id;
    downloadFileFromUrl(rewardPDFDownload(id), `certificate_${id}.pdf`, 'application/pdf');
  };

  return (
    <>
      { showCelebration &&
        <div className="confetti">
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
          <div className="confetti-piece"></div>
        </div>
      }

      <Dialog open={open}
              hideBackdrop={ showCelebration }
              fullWidth
              >
        <DialogTitle>
          <div className={`share-modal-title`} >
            { description }
          </div>
          {onClose && (
            <IconButton
              aria-label='close'
              onClick={onClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'black',
              }}
              >
                <CloseIcon />
            </IconButton>
          )}
        </DialogTitle>
        <div className={`container-img-share`} >
          <img src={ reward && reward.image_url } className="badge-image celebration-image social-share-image" alt={ `${ reward && reward.title } Badge` } />
        </div>
        { viewOnPublic &&
        <div className={`button-container`} >
          {certificate &&
            <Button sx={{w: 10, boxShadow:'4px 4px 4px 4px #f87433', mr: 2, ml: 1}}
                    onClick={() => handlePDFDownload()}
                    classes='MuiButton-contained'
            >
              {t('shareRewardModal:downloadButton')}
            </Button>
          }
          <Button variant="contained"
                  sx={{w: 10, boxShadow:'4px 4px 4px 4px #f87433', mr: 2, ml: 1}}
                  onClick={() => window.open(publicReward(reward.id), "_blank")}
                  classes='MuiButton-contained'
          >
            {certificate ? t('shareRewardModal:certificateButton') : t('shareRewardModal:defaultButton')}
          </Button>
        </div>
        }
        { showIcons &&
          <div className='container-share-icons'>
            <div className='share-label'>{t('publicReward:publicRewardPage_ShareIt')}</div>
            <SocialIcons reward={ reward } url={reward.external_url} />
          </div>
        }
      </Dialog>
    </>
  );
}

ShareRewardModal.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.node,
  reward: PropTypes.object,
  showCelebration: PropTypes.bool,
  onClose: PropTypes.func,
  viewOnPublic: PropTypes.bool,
  showIcons: PropTypes.bool,
};

export default ShareRewardModal;
